import { TaxIdentifierModel } from "./tax-identifier-model";
export interface UserTaxIdentifiersModel {
    id?: string;
    tax_identifier?: TaxIdentifierModel;
    id_value?: string;
    remarks?: string;
    document?: any;
    is_active?: boolean;
    status?: StatusModel;
    company?: string;
    rejection_reason?: string;
    updated_at?: Date;
    created_at?: Date;
    approved_at?: Date;
    created_by?: any;
    updated_by?: any;
    approved_by?: any;
    verified?: boolean;
    is_auto_verified?: boolean;
    admin_remarks?: string;
}
export class User_Tax_Identifiers implements UserTaxIdentifiersModel {
    id?: string;
    tax_identifier?: TaxIdentifierModel;
    id_value?: string;
    remarks?: string;
    document?: any;
    is_active?: boolean;
    status?: StatusModel;
    company?: string;
    rejection_reason?: string;
    updated_at?: Date;
    created_at?: Date;
    approved_at?: Date;
    created_by?: any;
    updated_by?: any;
    approved_by?: any;
    verified?: boolean;
    is_auto_verified?: boolean;
    admin_remarks?: string;

    constructor() {
        this.id = null
        this.tax_identifier = null;
        this.id_value = null;
        this.remarks = null;
        this.document = null;
        this.is_active = true;
        this.status = null;
        this.company = null;
        this.rejection_reason = null;
        this.updated_at = null;
        this.created_at = null;
        this.approved_at = null;
        this.created_by = null;
        this.updated_by = null;
        this.approved_by = null;
        this.verified = false;
        this.is_auto_verified = false;
        this.admin_remarks = null;
    }

    savePayloadToModel(data) {
        this.id = data.id;
        this.tax_identifier = data.tax_identifier;
        this.id_value = data.id_value;
        this.remarks = data.remarks;
        this.document = data.document;
        this.is_active = data.is_active;
        this.status = data.status;
        this.company = data.company;
        this.rejection_reason = data.rejection_reason;
        this.updated_at = data.updated_at;
        this.created_at = data.created_at;
        this.approved_at = data.approved_at;
        this.created_by = data.created_by;
        this.updated_by = data.updated_by;
        this.approved_by = data.approved_by;
        this.verified = data.verified;
        this.is_auto_verified = data.is_auto_verified;
        this.admin_remarks = data.admin_remarks;
    }

    getSavePayload() {
        return {
            id: this.id,
            tax_identifier: typeof this.tax_identifier == 'object' && this.tax_identifier != null ? this.tax_identifier.id : this.tax_identifier,
            id_value: this.id_value,
            remarks: this.remarks,
            document: typeof this.document == 'object' && this.document != null ? this.document.id : this.document,
            is_active: this.is_active,
            status: typeof this.status == 'object' && this.status != null ? this.status.id : this.status,
            company: this.company,
            rejection_reason: this.rejection_reason,
            verified: this.verified,
            is_auto_verified: this.is_auto_verified,
            admin_remarks: this.admin_remarks,
        }
    }

    getPayloadForKYC() {
        return {
            tax_identifier: typeof this.tax_identifier == 'object' && this.tax_identifier != null ? this.tax_identifier.id : this.tax_identifier,
            document: typeof this.document == 'object' && this.document != null ? this.document.id : this.document,
            verified: this.verified,
        }
    }
}

export interface StatusModel {
    id: string;
    updated_at: string;
    created_at: string;
    is_active: boolean;
    name: string;
    name_kyc: string;
    description: string;
    edit_allowed_internal: boolean;
    edit_allowed_external: boolean;
    dev_name: string;
    sequence: number;
    created_by?: any;
    updated_by?: any;
}